const HEX_RADIX = 16;

const TOKEN_BYTE_LENGTH = 32;

export function generateToken(): string {
  const bytes = new Uint8Array(TOKEN_BYTE_LENGTH);

  crypto.getRandomValues(bytes);

  return [...bytes]
    .map(byte => byte.toString(HEX_RADIX).padStart(2, "0"))
    .join("");
}

export async function hashToken(token: string): Promise<string> {
  const encoded = new TextEncoder().encode(token);
  const hashBuffer = await crypto.subtle.digest("SHA-256", encoded);

  return [...new Uint8Array(hashBuffer)]
    .map(byte => byte.toString(HEX_RADIX).padStart(2, "0"))
    .join("");
}

export async function verifyToken(
  token: string,
  hash: string,
): Promise<boolean> {
  const presentedHash = await hashToken(token);

  return presentedHash === hash;
}
